( function( $, document, window ) {
	'use strict';

	$( function() {
		const swiper = new Swiper('.js-featured-posts', {
			direction: 'horizontal',
            slidesPerView: 1.125,
			spaceBetween: 16,
			grabCursor: true,

			navigation: {
				nextEl: '.js-featured-posts-nav-next',
				prevEl: '.js-featured-posts-nav-prev',
			},

			breakpoints: {
				768: {
                    slidesPerView: 2.25,
                },

				1024: {
                    slidesPerView: 4,
                },
			},
		});
	} );
} )( jQuery, document, window );
